import { NavLink } from 'react-router';

import { FaIcon, GeocodedAddress, TextWithIcon } from '@/ui';
import { DateFormatter } from '@/features/shared/DateFormatter';
import { incidentDetailRoute } from '@/features/shared/routes';
import { reverseGeocode } from '@/features/shared/reverseGeocoding';
import type { IncidentListRow } from '@ngsos/portal-core/incidents';
import { IncidentPurposeBadge } from '@/features/shared/IncidentPurposeBadge';

export type IncidentListItemComponentProps = {
  item: IncidentListRow;
};

const LINK_CSS_CLASS = 'd-flex justify-content-between align-items-center p-2';

export function IncidentListItemComponent({ item }: IncidentListItemComponentProps) {
  return (
    <div className="incident-list-item-component">
      <NavLink
        to={incidentDetailRoute(item.id)}
        className={({ isActive }) => (isActive ? `${LINK_CSS_CLASS} active` : LINK_CSS_CLASS)}
      >
        <div className="d-flex flex-column gap- align-items-stretch text-decoration-none">
          {item.incidentLabel != null && item.incidentLabel !== '' && (
            <TextWithIcon icon="fa-light fa-tag" text={item.incidentLabel} textCssClass="fw-bold" />
          )}

          <TextWithIcon icon="fa-light fa-phone-volume" cssClass="d-flex align-items-center" contentCssClass="fw-bold">
            {item.title}
            <IncidentPurposeBadge purpose={item.purpose} />
          </TextWithIcon>
          <TextWithIcon icon="fa-light fa-clock">
            <span className="small">
              <DateFormatter date={item.createdTimeUtc} updateIntervalMs={1000} formatType="timeCombined" />
            </span>
          </TextWithIcon>
          <TextWithIcon icon="fa-light fa-location-crosshairs">
            <GeocodedAddress geoPoint={item.lastPosition} reverseGeocode={reverseGeocode} />
          </TextWithIcon>

          {item.agencyNames.length > 1 && (
            <TextWithIcon icon="fa-light fa-siren-on" text={item.agencyNames.join(', ')} textCssClass="small" />
          )}
        </div>
        <div>
          <FaIcon icon="fa-light fa-chevron-right" />
        </div>
      </NavLink>
    </div>
  );
}
